
import { cn } from "@/lib/utils"

// Interface for FooterButtonLink props
interface FooterButtonLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: "outline" | "playstore"
  icon?: React.ReactNode
}

// FooterButtonLink component
export function FooterButtonLink({
  className,
  variant = "outline",
  icon,
  children,
  ...props
}: FooterButtonLinkProps) {
  return (
    <a
      className={cn(
        "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
        {
          "border border-brand-shape-50 text-brand-shape-50 hover:bg-brand-shape-100 hover:text-brand-primary-60":
            variant === "outline",
          "bg-white text-black border border-brand-shape-50 hover:bg-gray-100":
            variant === "playstore",
        },
        "h-10 px-4 py-2 space-x-2",
        className
      )}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {icon && <span className="text-lg">{icon}</span>}
      <span>{children}</span>
    </a>
  )
}